import React, { useCallback, useContext } from 'react';
import FormComponent from '../../../FormComponent/FormComponent';
import { Portal, svgSprite } from '../../../../../hybrid/wrappers';
import { dataSender } from '../../../../../common/utils/router';
import UserContext from '../../../../../common/utils/getContext';
import { useWindowDimensions } from '../../../../../common/utils/windowDimensions';
import T from '../../../../../common/components/T';
import css from './FormModal.module.scss';
import { clearUserCache } from '../../../../../common/utils/memo';
import classNames from 'classnames';

const FormModal = ({
    setOpen,
    attribute,
    options,
    modalStyles,
    modalSendUrl,
    modalSendMethod,
    modalAfterSendFunc,
    message,
    userToken,
    resetUrl,
    titlePopup,
    cancelFuncs,
    buttonText
}) => {
    const widthDimensions = useWindowDimensions();
    const mobile = widthDimensions < 768;
    const { setAlertData, lang } = useContext(UserContext);
    const modalAfterSend = useCallback(
        (data, sendData) => {
            clearUserCache();
            const resMessage = data?.data?.message;
            setOpen(false);
            setAlertData({
                type: 'success',
                cont: resMessage || message?.success || (message?.success === false ? message.success : true),
                default: 'success_save_data'
            });
            if (modalAfterSendFunc) {
                modalAfterSendFunc(data, sendData);
            }
        },
        [message?.success, modalAfterSendFunc, setAlertData, setOpen]
    );
    const sender = useCallback(
        (formData, setAllowedSend, setFieldsErr) => {
            const sendData = resetUrl
                ? {
                      ...formData,
                      attribute,
                      url: resetUrl
                  }
                : { ...formData, attribute };
            dataSender(
                modalSendUrl,
                modalSendMethod || 'POST',
                sendData,
                (response) => modalAfterSend(response, sendData),
                (data) => {
                    if (message?.error === false) {
                        setAlertData(false);
                    } else if (data.message) {
                        setAlertData({ type: 'error', cont: data.message });
                    }
                    if (data.errors && Object.keys(data.errors)) {
                        setFieldsErr(data.errors);
                    }
                    if (data.message || (data.errors && Object.keys(data.errors))) {
                        setAllowedSend(true);
                        setAlertData({ type: 'error', cont: data.message });
                    }
                },
                userToken,
                lang
            );
        },
        [resetUrl, attribute, modalSendUrl, modalSendMethod, userToken, lang, modalAfterSend, message?.error, setAlertData]
    );
    const modalSendData = { url: modalSendUrl, sender };
    const { infoTextBlock } = options[0];

    return (
        <Portal customClass={mobile ? 'modalBottom' : 'modal'} close={() => setOpen(false)}>
            <div className={css.modalContentWrapper}>
                <div onClick={() => setOpen(false)} className={css.modalCloseBtn}>
                    {!mobile ? (
                        <div className={classNames('circleButton', css.modalCloseBtnOffice)}>
                            {svgSprite('cross', { className: css.modalCloseBtnSvg })}
                        </div>
                    ) : (
                        <div className={css.modalCloseBtnDecor} />
                    )}
                </div>
                {!!titlePopup && <p className={css.formModalSubtitle}> {titlePopup} </p>}
                <div className={css.formModalInfoBlockContent}>
                    {options[0]?.prevValue || options[0]?.prevValueText || infoTextBlock ? (
                        <div className={css.formModalInfoBlockModal}>
                            <div className={css.formModalPrevValueTextBlock}>
                                <p className={css.formModalPrevValueText}>{options[0].prevValueText}</p>
                                <p className={css.formModalPrevValue}>{options[0].prevValue}</p>
                            </div>
                            {infoTextBlock ? <p className={css.formModalInfoTextBlock}>{infoTextBlock}</p> : null}
                        </div>
                    ) : null}
                    <FormComponent
                        data={options}
                        formName={`emailWidget_${attribute}`}
                        formStyles={modalStyles || {}}
                        sendData={modalSendData}
                        message={message}
                        funcs={{}}
                        buttons={[
                            ...(cancelFuncs
                                ? [
                                      {
                                          type: 'cancel',
                                          clickFunc: cancelFuncs.web.onClick,
                                          buttonText: <T textName='close' defaultStr='Закрыть' page='all' />
                                      }
                                  ]
                                : []),
                            {
                                buttonText: buttonText || <T textName='save' defaultStr='Сохранить' page='all' />,
                                type: 'ok'
                            }
                        ]}
                    />
                </div>
            </div>
        </Portal>
    );
};
export default FormModal;
